<form [formGroup]="form" *ngVar="bannerValues$ | async as bannerValues">
  <div class="flex justify-between mb-4" *ngVar="editMode$ | async as editMode">
    <div class="flex space-x-4 items-center">
      <label for="vendor" class="text-sm">Select Vendor: </label>
      <ng-select
        id="vendor"
        class="w-60"
        formControlName="vendorId"
        placeholder="Select"
        bindValue="value"
        [loading]="(vendorListLoading$ | async)!"
        [clearable]="false"
        [searchable]="false"
        [items]="vendorList"
      >
      </ng-select>
    </div>
    <div class="flex space-x-2">
      <aux-button
        label="Edit"
        icon="pencil"
        *ngIf="!editMode && !!form.getRawValue().vendorId"
        [onClick]="editModeEnable()"
      ></aux-button>
      <aux-button
        label="Cancel"
        *ngIf="editMode"
        icon="x"
        variant="secondary"
        [onClick]="cancelEdit"
      ></aux-button>
      <aux-button
        label="Save"
        icon="check"
        variant="success"
        *ngIf="editMode"
        [disabled]="submitButtonDisabled$ | async"
        [onClick]="saveSiteContractSetting"
      ></aux-button>
    </div>
  </div>
  <aux-investigator-forecast-saved-source-banner
    *ngIf="!!bannerValues.source"
    [source]="bannerValues.source"
    [amount]="bannerValues.amount"
    class="mb-7"
  ></aux-investigator-forecast-saved-source-banner>

  <p class="my-4 font-bold">Select Source</p>
  <div class="grid grid-cols-[1fr_2fr] relative">
    <aux-investigator-forecast-source-select
      [control]="form.controls.source"
      [sources]="sources"
    ></aux-investigator-forecast-source-select>

    <aux-investigator-forecast-overview
      *ngIf="!!form.getRawValue().source"
      [form]="$any(form)"
      [formValues]="$any(form.getRawValue())"
    ></aux-investigator-forecast-overview>
  </div>
</form>
